import { Icon } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

function FloatingCartButton({
  opened,
  products,
  isTransitioning,
  isFloatingButtonShown,
  handleToggle,
  location
}) {
  return (
    <S.FloatingCartButton
      type="button"
      onClick={() => handleToggle(!opened)}
      location={location}
      isTransitioning={isTransitioning}
      opened={opened}
      variant="outlined"
      rounded
      isFloatingButtonShown={isFloatingButtonShown}
    >
      <S.FloatingCartButtonBadge>{products.length}</S.FloatingCartButtonBadge>
      <Icon name="shopping-bag" />
    </S.FloatingCartButton>
  );
}

FloatingCartButton.propTypes = {
  opened: PropTypes.bool,
  products: PropTypes.array,
  isTransitioning: PropTypes.bool,
  isFloatingButtonShown: PropTypes.bool,
  handleToggle: PropTypes.func,
  location: PropTypes.string
};

export { FloatingCartButton };
